import axios from 'axios'
import QS from 'qs'
import { Loading } from 'element-ui'
import wmsMessage from '@/utils/message'
import store from '@/store'
import router from '@/router'
import { baseURL } from '@/const/env'
import gray from '@sniff/gray'

import codeLang from '@/i18n/code'
import { t } from '@/i18n/index'
const graify = gray(baseURL())

// const graify = gray(baseURL())

const service = axios.create({
  baseURL: baseURL(),
  timeout: 180000
  // headers: {'X-Custom-Header': 'foobar'}
})

/****** request 拦截器 ==> 对请求参数做处理 ******/
const loading = {
  num: 0,
  data: null,
  open: function () {
    this.num += 1
    if (!this.data) {
      this.data = Loading.service({
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    }
  },
  close: function () {
    this.num -= 1
    if (this.num <= 0) {
      this.data?.close()
      this.data = null
    }
  }
}
service.interceptors.request.use(
  async (config) => {
    console.log('config',config)
    const curVersion = window.curVersion ?? {}
    if (curVersion.time + 10 * 60 * 1000 > Date.now()) {
      // 1:client 2:system 3:wms
    } else {
      axiosV.post('/customer/getClientVersion?project=3', {}).then((res) => {
        if (!curVersion.version) {
          //
        } else if (curVersion.version !== res.data.data) {
          requestAnimationFrame(() => {
            location.reload()
          })
        }
        curVersion.version = res.data.data
        curVersion.time = Date.now()
        window.curVersion = curVersion
      })
    }
    const params = config.data || {}
    console.log('params', params)
    if(!params.noMask) {
      loading.open()
    }
    const _token = store.getters.getToken
    const isAuth = config.url.indexOf('/customer/users/token') >= 0
    config.headers['X-GRAY-TAG'] = process.env.VUE_APP_TAG
    if (!isAuth && !!_token) {
      config.headers['X-AuthToken'] = _token
    } else if (!isAuth && !_token) {
      wmsMessage.error(t('未登录'))
      setTimeout(async (_) => {
        await store.dispatch('auth/removeAuth')
        await store.dispatch('menu/removeMenu')
        await store.dispatch('baseData/removeRegionList')
        await router.push('/auth')
      }, 200)
    }
    await graify(config)
    // console.log(config)
    return config
  },
  (error) => {
    //请求错误处理
    loading.close()
    wmsMessage.error(error)
    Promise.reject(error)
  }
)

/****** response 拦截器==> 对响应做处理 ******/
service.interceptors.response.use(
  (response) => {
    //成功请求到数据
    loading.close()
    let _data = {}
    //这里根据后端提供的数据进行对应的处理
    if (response.data.code) {
      if (parseInt(response.data.code) !== 0) {
        // 0 为正常
        // console.log(response.data.code)
        _data = {
          ...response.data,
          code: parseInt(response.data.code)
        }

        if (parseInt(response.data.code) != '26010019' && parseInt(response.data.code) != '26000011' && response.data.code != "24010063") {
          const lang = localStorage.getItem('lang') ?? 'ja'
          wmsMessage.error(lang === 'ja' ? codeLang[lang][response.data.code] ?? t(response.data.msg) : response.data.msg);
        }
        if (response.data.code == '10000000' || response.data.msg == '用户token过期' || response.data.code == "24010063") {
          setTimeout(async (_) => {
            await store.dispatch('auth/removeAuth')
            await store.dispatch('menu/removeMenu')
            await store.dispatch('baseData/removeRegionList')
            await router.push('/auth')
          }, 200)
        }
      } else {
        _data = {
          ...response.data,
          code: parseInt(response.data.code)
        }
      }
      return Promise.resolve(_data)
    } else {
      return Promise.resolve(response)
    }
  },
  (error) => {
    //响应错误处理
    loading.close()
    // console.log(error)
    const { response, message, name } = error
    // console.log('netWork-response', JSON.stringify(response))
    // console.log('netWork-message', message)
    // console.log('netWork-name', name)
    wmsMessage.error('网络异常，请重试')
    return Promise.reject(error)
  }
)

export const get = function (url, params, config) {
  let uri = url
  if (params) {
    uri = Object.keys(params).reduce((pre, item, array) => {
      const flag = params[item] === '' || params[item] === null
      return flag ? pre : pre + `${item}=${params[item]}&`
    }, `${url}?`)
  }
  return service.get(uri, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export const getFrom = function (url, params, config) {
  return service.get(url, {
    params,
    paramsSerializer: function (params) {
      return QS.stringify(params, { arrayFormat: 'comma' })
    }
  })
}

export const post = function (url, params, config) {
  // console.log(url, params)
  return service.post(url, params, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const post_OSS = function (url, params, config) {
  // console.log(url, params)
  return service.post(url, params, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export const post_query = function (url, params, config) {
  let uri = url + '?' + QS.stringify(params, { arrayFormat: 'comma' })
  return service.post(uri, params, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export const put = function (url, params, config) {
  // console.log(url, params)
  return service.put(url, params, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const post_blob = function (url, params, config) {
  // console.log(url, params)
  return service.post(url, params, {
    responseType: 'blob'
  })
}
export const post_arraybuffer = function (url, params, config) {
  // console.log(url, params)
  return service.post(url, params, {
    responseType: 'arraybuffer'
  })
}

const axiosV = axios.create({
  timeout: 3 * 60 * 1000,
  baseURL: baseURL()
})
